// src/pages/ForgotPassword.jsx
import React, { useState } from "react";
import { auth } from '../utils/init-firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Link } from 'react-router-dom';
import '../index.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setSuccess('Password reset email sent! Please check your inbox.');
      setEmail(''); // Clear the input after successful submission
    } catch (err) {
      console.error('Error sending password reset email:', err);
      switch (err.code) {
        case 'auth/user-not-found':
          setError('No account found with this email address');
          break;
        case 'auth/invalid-email':
          setError('Please enter a valid email address');
          break;
        case 'auth/too-many-requests':
          setError('Too many attempts. Please try again later');
          break;
        default:
          setError('Failed to send reset email. Please try again');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-header">
          <h1>Reset Password</h1>
          <p>
            Enter your email address and we'll send you instructions to reset your password.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="forgot-password-form">
          <div className="forgot-password-input-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="forgot-password-input"
              disabled={isLoading}
              autoComplete="email"
              aria-label="Email address"
            />
          </div>

          <button
            type="submit"
            className="forgot-password-submit"
            disabled={isLoading}
            aria-label={isLoading ? "Sending reset email..." : "Send reset email"}
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>

          {error && (
            <div className="forgot-password-error" role="alert">
              {error}
            </div>
          )}

          {success && (
            <div className="forgot-password-success" role="alert">
              {success}
            </div>
          )}

          <div className="forgot-password-links">
            <Link to="/login">Back to Login</Link>
            <span>•</span>
            <Link to="/register">Create Account</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
